const VERBOSE_ENV_FLAGS = ['1', 'true', 'yes', 'on'];
const LOCAL_STORAGE_KEY = 'ugrid.verboseLogging';

function readLocalToggle(): boolean | null {
  if (typeof window === 'undefined') return null;
  try {
    if (
      Object.prototype.hasOwnProperty.call(window as any, '__UGRID_VERBOSE_LOGS__')
    ) {
      return Boolean((window as any).__UGRID_VERBOSE_LOGS__);
    }
  } catch {
    // ignore
  }

  if (typeof localStorage === 'undefined') return null;
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === null) return null;
    return VERBOSE_ENV_FLAGS.includes(stored.toLowerCase());
  } catch {
    return null;
  }
}

function readEnvToggle(): boolean {
  const fallback =
    process.env.REACT_APP_VERBOSE_LOGGING ||
    process.env.REACT_APP_VERBOSE_LOGS ||
    process.env.REACT_APP_DEBUG_LOGS ||
    '';
  return VERBOSE_ENV_FLAGS.includes(fallback.toLowerCase());
}

export function isVerboseLoggingEnabled(): boolean {
  const localToggle = readLocalToggle();
  if (localToggle !== null) {
    return localToggle;
  }
  return readEnvToggle();
}

function logWithLevel(method: 'log' | 'debug' | 'warn' | 'info', args: any[]) {
  if (!isVerboseLoggingEnabled()) return;
  const fn = console[method] ?? console.log;
  fn(...args);
}

export function verboseLog(...args: any[]) {
  logWithLevel('log', args);
}

export function verboseDebug(...args: any[]) {
  logWithLevel('debug', args);
}

export function verboseWarn(...args: any[]) {
  logWithLevel('warn', args);
}

export function verboseInfo(...args: any[]) {
  logWithLevel('info', args);
}

export function setVerboseLoggingEnabled(enabled: boolean) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    // ignore
  }
}










































